import React from "react";
import Project from "./Project";
import { projects } from "./utils/data";

const Projects = () => {
  return (
    <div
      id="projects"
      className="font-mono w-full h-full mt-[10vh] flex flex-col items-center mb-[10vh]"
    >
      <h1 className="text-white font-bold text-[35px] mb-[30px]">Projects</h1>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-20">
        {projects.map((project, index) => (
          <Project project={project} key={index} />
        ))}
      </div>
    </div>
  );
};

export default Projects;
